<template>
  <b-field>
    <p v-for="option in options" class="control">
      <b-tooltip :label="option.label">
	<b-button
	  :icon-left="option.icon"
	  @click="value = option.value"
	  :class="{ 'is-active': value === option.value }"
	>
	</b-button>
      </b-tooltip>
    </p>
  </b-field>
</template>

<script>
 import selectMixin from '@/mixins/select.js'

 export default {
   mixins: [selectMixin],
   props: {
     defaultValue: {
       type: String,
       default: 'combined'
     }
   },
   data() {
     return {
       options: [
	 {
	   icon: 'object-group',
	   value: 'combined',
	   label: this.$t('Combined snippets')
	 },
	 {
	   icon: 'align-left',
	   value: 'text',
	   label: this.$t('Text snippets')
	 },
	 {
	   icon: "images",
	   value: 'image',
	   label: this.$t('Image snippets')
	 }
       ]
     }
   }
 }
</script>
